import { BsCheck, BsImage } from 'react-icons/bs';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import theme from '@/common/theme';
import { Col, Row } from '@/components/grid/grid-component';
import { ViewSmallTitleText } from '@/utils/global-fonts';

const Div = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: center;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  margin-top: auto;
  width: 100%;
`;

const ImageDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GoBack = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: ${() => theme.COLOR_BG_DARK} !important;
  margin-bottom: 25px !important;
  padding: 24px !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  justify-content: end !important;
`;

const MainOption = styled.div`
  background-color: ${() => theme.COLOR_BG_DARK};
  min-height: 100%;
  justify-content: flex-start;
  display: flex;
  width: 100%;
`;

const MainVariant = styled.div`
  background-color: ${() => theme.COLOR_BG_DARK};
  min-height: 100%;
  justify-content: flex-start;
  display: flex;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;
const ImageStyle = styled.img`
  width: 100%;
  max-width: 200px;
  border-radius: 4px;
`;

const ButtonRowStyle = styled(Row)`
  justify-content: flex-end !important;
  margin-bottom: 0;
  width: 100% !important;
`;

const HeadingRowStyle = styled(Row)`
  justify-content: flex-end !important;
  margin-bottom: 0 !important;
  width: 100% !important;
`;

const DivStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const Label = styled(ViewSmallTitleText)`
  margin-bottom: 9px;
`;

const SuppliersContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledStatusCol = styled(Col)`
  display: flex;
  justify-content: end;
`;

const StyledUserTypeCol = styled(Col)`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 0px;
`;

const StyledRow = styled(Row)`
  display: flex;
  width: 100%;
  margin: 0 0 0 0px;
  justify-content: center !important;
  align-items: center;
`;

const MainStyledCol = styled(Col)`
  max-width: 100%;
  width: 100%;
`;

const ButtonStyledCol = styled(Col)`
  padding-left: 0;
  padding-right: 0;
`;

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const Checkbox = styled.div`
  display: flex;
  border: 1px solid ${theme.COLOR_GREY};
  border-radius: 2px;
  background-color: ${theme.COLOR_BLACK};
`;

const CheckMark = styled(BsCheck)`
  margin: 1px;
  height: 20px;
  width: 20px;
  color: ${theme.COLOR_WHITE};
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin-left: 13px;
  letter-spacing: 0.2px;
  color: ${theme.COLOR_BLACK};
`;

const Span = styled.span`
  display: flex;
  align-items: center;

  .title {
    margin: 0 16px 0 0;
  }
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const ImageColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding-left: 24px;
`;

const InfoColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding-right: 24px;
`;

const IconWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  margin: 0px 10px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  width: 100%;
  border: 1px solid ${() => theme.COLOR_GREY2};
  border-radius: 8px;
`;

const LinkWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  gap: 32px;
`;

const LinkContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledLink = styled(Link)`
  font-size: 12px;
  color: ${(props) => props.theme.COLOR_LINK};
`;

const ThumbnailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  text-align: left;
`;

const NoThumbnail = styled(BsImage)`
  color: ${theme.COLOR_GREY4};
  width: auto;
  height: 120px;
`;

const StyledDiv = {
  Div,
  RowStyle,
  MainOption,
  MainVariant,
  Container,
  DivStyle,
  Label,
  ImageStyle,
  ButtonRowStyle,
  HeadingRowStyle,
  StyledUserTypeCol,
  StyledRow,
  ButtonStyledCol,
  MainStyledCol,
  StyledStatusCol,
  SuppliersContainer,
  CheckboxContainer,
  Checkbox,
  CheckMark,
  CheckboxLabel,
  ImageDiv,
  GoBack,
  Span,
  Header,
  ImageColumn,
  InfoColumnWrapper,
  IconContainer,
  IconWrapper,
  LinkWrapper,
  LinkContent,
  StyledLink,
  ThumbnailWrapper,
  NoThumbnail,
};

export default StyledDiv;
